module.exports = __webpack_public_path__ + "static/media/s3.50398de0.svg";